import { create } from 'zustand';

const useJoinNonProfitDialogStore = create((set) => ({
  open: false,
  nonProfit: null,
  step: 'about',
  setOpen: (isOpen, nonProfit, step = 'about') =>
    set(() => ({ open: isOpen, nonProfit: nonProfit, step: step })),
  join: () => {},
}));

export default useJoinNonProfitDialogStore;
